import React from "react";
import { Link, useLocation } from "react-router-dom";
import { HOME } from "@/constants/testIds";

export default function Nav() {
  const { pathname } = useLocation();
  return (
    <header className="relative z-30">
      <nav className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid={HOME.navBrand}>
          <img
            src="/heirloom-logo.png"
            alt="The Heirloom Pet"
            className="h-14 md:h-16 w-auto transition-transform duration-700 group-hover:scale-[1.04]"
            style={{ filter: "drop-shadow(0 2px 6px rgba(212,175,55,0.15))" }}
          />
        </Link>

        <div className="hidden md:flex items-center gap-8 font-ui text-[13px]">
          <Link to="/create" className={`transition-colors hover:text-[var(--rb-gold)] ${pathname === "/create" ? "text-[var(--rb-gold)]" : "text-[var(--rb-text-body)]"}`}>Create Memorial</Link>
          <Link to="/ecard" className={`transition-colors hover:text-[var(--rb-gold)] ${pathname === "/ecard" ? "text-[var(--rb-gold)]" : "text-[var(--rb-text-body)]"}`}>Send an eCard</Link>
          <Link to="/gallery" className={`transition-colors hover:text-[var(--rb-gold)] ${pathname === "/gallery" ? "text-[var(--rb-gold)]" : "text-[var(--rb-text-body)]"}`}>Garden of Remembrance</Link>
          <Link to="/commission" className={`transition-colors hover:text-[var(--rb-gold)] ${pathname === "/commission" ? "text-[var(--rb-gold)]" : "text-[var(--rb-text-body)]"}`}>Commission</Link>
          <Link to="/about" className={`transition-colors hover:text-[var(--rb-gold)] ${pathname === "/about" ? "text-[var(--rb-gold)]" : "text-[var(--rb-text-body)]"}`}>Our Story</Link>
        </div>

        <Link to="/admin/login" className="font-ui text-[10px] tracking-[0.25em] uppercase text-[var(--rb-text-muted)] hover:text-[var(--rb-gold)] transition-colors" data-testid={HOME.ctaAdminLogin}>
          Studio
        </Link>
      </nav>
    </header>
  );
}
